import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import "./Feedbacktemplatemaster.css";
import toast from "react-hot-toast";

export default function Feedbacktemplatemaster() {
  const API_BASE_URL = "https://prodapi.iworkkz.com:9095";
  const API_KEY = "X4gfacRza++DrL%2FqFYkhZJAuiuuJEsGwmfJz7tZHGi4%3D";

  const [robotList, setRobotList] = useState([]);
  const [selectedRobot, setSelectedRobot] = useState("");

  const [questionList, setQuestionList] = useState([]);
  const [loadingQuestions, setLoadingQuestions] = useState(false);

  // ✅ LOAD ROBOT LIST
  useEffect(() => {
    const url = `${API_BASE_URL}/API/Robots/active?key=${API_KEY}`;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch robots");
        return res.json();
      })
      .then((data) => setRobotList(data))
      .catch((err) => {
        console.error("Robot Load Error:", err.message);
        toast.error("Failed to load robots");
      });
  }, []);

  // ✅ LOAD QUESTIONS ON ROBOT SELECT
  useEffect(() => {
    if (!selectedRobot) {
      setQuestionList([]);
      return;
    }

    setLoadingQuestions(true);

    const url = `${API_BASE_URL}/API/template/questions?key=${API_KEY}&robotId=${selectedRobot}`;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch questions");
        return res.json();
      })
      .then((data) => {
        const formatted = (data?.questions || []).map((q) => ({
          QUESTION_ID: q.QUESTIONID,
          ROBOTID: q.ROBOTID,
          QUESTION_TEXT: q.QUESTION_TEXT,
          QUESTION_TYPE: q.QUESTION_TYPE || "Rating",
          STATUS: q.STATUS || "ACTIVE",
        }));

        setQuestionList(formatted);
      })
      .catch((err) => {
        console.error("Question Load Error:", err.message);
        toast.error("Failed to load questions");
        setQuestionList([]);
      })
      .finally(() => {
        setLoadingQuestions(false);
      });
  }, [selectedRobot]);

  // ✅ ADD NEW QUESTION
  const handleAddQuestionRow = () => {
    const newRow = {
      QUESTION_ID: null,
      QUESTION_TEXT: "",
      QUESTION_TYPE: "Rating",
      STATUS: "ACTIVE",
    };

    setQuestionList((prev) => [...prev, newRow]);
  };

  // ✅ EDIT HANDLERS
  const handleQuestionChange = (index, value) => {
    const updated = [...questionList];
    updated[index].QUESTION_TEXT = value;
    setQuestionList(updated);
  };

  const handleTypeChange = (index, value) => {
    const updated = [...questionList];
    updated[index].QUESTION_TYPE = value;
    setQuestionList(updated);
  };

  const handleStatusToggleQuestion = (index) => {
    const updated = [...questionList];
    updated[index].STATUS =
      updated[index].STATUS === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    setQuestionList(updated);
  };

  // ✅ DELETE ROW
  const handleDeleteRow = (index) => {
    const updated = [...questionList];
    updated.splice(index, 1);
    setQuestionList(updated);
  };

  // ✅ SAVE ALL QUESTIONS
  const handleSaveQuestions = () => {
    if (!selectedRobot) {
      toast.warning("Please select a robot first");
      return;
    }

    const validQuestions = questionList.filter(
      (q) => q.QUESTION_TEXT.trim() !== ""
    );

    if (validQuestions.length === 0) {
      toast.warning("Add at least one question");
      return;
    }

    const selectedRobotObj = robotList.find(
      (r) => String(r.ID) === String(selectedRobot)
    );

    const payload = {
      ROBOTID: Number(selectedRobot),
      NAME: selectedRobotObj?.NAME || "",
      QUESTIONS: validQuestions.map((q) => ({
        QUESTION_ID: q.QUESTION_ID || null,
        ROBOTID: String(selectedRobot),
        QUESTION_TEXT: q.QUESTION_TEXT,
        QUESTION_TYPE: q.QUESTION_TYPE,
        STATUS: q.STATUS,
      })),
    };

    console.log("FINAL PAYLOAD ✅", payload);

    const url = `${API_BASE_URL}/API/template?key=${API_KEY}`;

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Save failed");
        return res.json();
      })
      .then(() => {
        toast.success("Questions saved successfully ✅");
      })
      .catch((err) => {
        console.error("Save Error:", err.message);
        toast.error("Failed to save questions ❌");
      });
  };

  const handlePasteQuestions = (e, rowIndex) => {
    const pastedText = e.clipboardData.getData("text");

    // ✅ If not multi-row → normal paste
    if (!pastedText.includes("\n") && !pastedText.includes("\t")) return;

    e.preventDefault(); // ✅ Stop default paste

    const rows = pastedText
      .split(/\r?\n/)
      .map((row) => row.split("\t")) // ✅ Split by Excel columns
      .map((cols) => cols.map((c) => c.trim()))
      .filter((cols) => cols[0]); // ✅ At least question required

    if (rows.length === 0) return;

    const updated = [...questionList];

    // ✅ FIRST ROW → goes into current row
    updated[rowIndex] = {
      ...updated[rowIndex],
      QUESTION_TEXT: rows[0][0] || "",
      QUESTION_TYPE: rows[0][1] || "Rating",
      STATUS: rows[0][2] || "ACTIVE",
    };

    // ✅ REMAINING ROWS → create new rows
    const extraRows = rows.slice(1).map((cols) => ({
      QUESTION_ID: null,
      QUESTION_TEXT: cols[0] || "",
      QUESTION_TYPE: cols[1] || "Rating",
      STATUS: cols[2] || "ACTIVE",
    }));

    const finalList = [
      ...updated.slice(0, rowIndex + 1),
      ...extraRows,
      ...updated.slice(rowIndex + 1),
    ];

    setQuestionList(finalList);
  };

  return (
    <>
      <Navbar />

      <div className="Pagename">
        <div>Feedback Template Master</div>
      </div>

      <div className="Secondbar">
        <label>Select Robot</label>

        <select
          value={selectedRobot}
          onChange={(e) => setSelectedRobot(e.target.value)}
        >
          <option value="">Select Robot</option>
          {robotList.map((robot) => (
            <option key={robot.ID} value={robot.ID}>
              {robot.NAME}
            </option>
          ))}
        </select>
      </div>

      {/* ✅ TABLE */}
      {selectedRobot && (
        <div className="table-container">
          <table className="robot-table">
            <thead>
              <tr>
                <td>Question</td>
                <td>Type</td>
                <td>Status</td>
                <td>Action</td>
              </tr>
            </thead>

            <tbody>
              {loadingQuestions ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    Loading questions...
                  </td>
                </tr>
              ) : questionList.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No questions found
                  </td>
                </tr>
              ) : (
                questionList.map((item, index) => (
                  <tr key={index}>
                    {/* ✅ QUESTION */}
                    <td>
                      {/* <input
                        type="text"
                        value={item.QUESTION_TEXT}
                        onChange={(e) =>
                          handleQuestionChange(index, e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "6px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                        }}
                      /> */}
                      <input
                        type="text"
                        value={item.QUESTION_TEXT}
                        onChange={(e) =>
                          handleQuestionChange(index, e.target.value)
                        }
                        onPaste={(e) => handlePasteQuestions(e, index)} // ✅ PASTE FEATURE
                        style={{
                          width: "100%",
                          padding: "6px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                        }}
                      />
                    </td>

                    {/* ✅ TYPE */}
                    <td>
                      <select
                        value={item.QUESTION_TYPE}
                        onChange={(e) =>
                          handleTypeChange(index, e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "6px",
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                        }}
                      >
                        <option value="Rating">Rating</option>
                        <option value="Dropdown">Dropdown</option>
                      </select>
                    </td>

                    {/* ✅ STATUS */}
                    <td>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={item.STATUS === "ACTIVE"}
                          onChange={() => handleStatusToggleQuestion(index)}
                        />
                        <span className="slider"></span>
                      </label>
                    </td>

                    {/* ✅ DELETE ONLY */}
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="fa-solid fa-trash fa-lg edit-icon"
                        title="Delete"
                        onClick={() => handleDeleteRow(index)}
                      ></i>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* ✅ FOOTER BUTTONS */}
          <div className="popup-buttons">
            <button className="btn-save" onClick={handleAddQuestionRow}>
              + Add Question
            </button>

            <button className="btn-save" onClick={handleSaveQuestions}>
              Save
            </button>
          </div>
        </div>
      )}
    </>
  );
}
